// extracted by mini-css-extract-plugin
export default {"box":"sUeUedwEKML6S6npu6De"};